import React, { useEffect, useState } from "react";
import { useAuth } from "../../Store/auth-context";
import { Product } from "../../Store/interfaces";
import { useScheinContext } from "../../Store/schein-context";
import ProductGroup from "./ProductGroup";

interface ProductContainerProps {}

const ProductContainer: React.FC<ProductContainerProps> = () => {
  const { products, selectedProducts, setSelectedProducts, searchedProducts } =
    useScheinContext();

  const [sortedGroupedProducts, setSortedGroupedProducts] = useState<{
    [group: string]: Product[];
  }>({});
  const { bearbeiter } = useAuth();
  useEffect(() => {
    // Use ternary operator to select between searchedProducts and products.
    // This part is already correct but added clarity in comment.
    const productList =
      searchedProducts.length > 0 ? searchedProducts : products;
    // const productList = products;

    // Group products by artikelgruppe
    const groupedProducts = productList.reduce<{ [group: string]: Product[] }>(
      (acc, product) => {
        acc[product.artikelgruppe] = acc[product.artikelgruppe] || [];
        acc[product.artikelgruppe].push(product);
        return acc;
      },
      {}
    );
    // Sort groups by artikelgruppe and then reconstruct the grouped object
    // No need to cast 'products' inside the reduce, TypeScript should infer the correct type
    const sortedGroupedProds = Object.entries(groupedProducts)
      .sort(([groupA], [groupB]) => groupA.localeCompare(groupB))
      .reduce<{ [group: string]: Product[] }>((acc, [group, products]) => {
        acc[group] = products;
        return acc;
      }, {});
    setSortedGroupedProducts(sortedGroupedProds);
  }, [searchedProducts, products]);

  // const handleProductSelect = (productId: number) => {
  //   // console.log("ProductContainer2 | handleProductSelect");
  //   try {
  //     const selectedProduct = products.find(
  //       (product) => product.id === productId
  //     )!;

  //     // Prüfung ob Produkt bereits selected war
  //     const prodCurrentlySelected = selectedProducts.find(
  //       (product) => product.id === productId
  //     );

  //     if (prodCurrentlySelected) {
  //       const updatedProducts = selectedProducts.filter((product) => {
  //         return product.id !== productId;
  //       });
  //       // console.log(updatedProducts.length + " products are now selected");
  //       setSelectedProducts(updatedProducts);
  //     } else {
  //       selectedProduct.provisionsnehmer = bearbeiter;
  //       selectedProduct.provisionstyp = "Technik";

  //       const newSelectedProducts: Product[] = [
  //         ...selectedProducts,
  //         selectedProduct,
  //       ];
  //       setSelectedProducts(newSelectedProducts);
  //     }
  //     // console.log("ProductContainer2 | handleProductSelect | products.length = " + products.length);
  //   } catch (error: unknown) {
  //     // Handle the error, log it, or perform any necessary actions
  //     if (error instanceof Error) {
  //       console.error("Error:", error.message);
  //       console.error(error.stack);
  //     } else {
  //       // Handle unexpected non-Error types
  //       console.error("Unexpected error type:", error);
  //     }
  //   }
  // };

  const handleProductSelect = (productId: number) => {
    const selectedProduct = products.find(
      (product) => product.id === productId
    );
    if (!selectedProduct) return;

    const isAlreadySelected = selectedProducts.some(
      (product) => product.id === productId
    );

    if (isAlreadySelected) {
      // Deselect
      const updated = selectedProducts.filter((p) => p.id !== productId);
      setSelectedProducts(updated);
    } else {
      // Deep copy + Menge initialisieren
      const newProduct = {
        ...selectedProduct,
        menge: 1,
        provisionsnehmer: bearbeiter,
        provisionstyp: "Technik",
      };
      setSelectedProducts([...selectedProducts, newProduct]);
    }
  };

  return (
    <div>
      {Object.entries(sortedGroupedProducts).map(([group, products]) => (
        <ProductGroup
          key={group}
          groupName={group}
          groupProducts={products}
          onProductSelect={handleProductSelect}
        />
      ))}
    </div>
  );
};

export default ProductContainer;
